import React from 'react'
import { WbTooltip, WbTooltipHost } from '@workbench/react/dist'
import { Booking } from 'api/types'
import { isEditCloseDate } from 'utils/bookingDateUtils'
import { LinkButton } from 'components'
import { useTranslation } from 'react-i18next'

interface EditBookingButtonProps {
  booking: Booking
}

export const EditBookingButton: React.FunctionComponent<EditBookingButtonProps> =
  ({ booking }) => {
    const { t } = useTranslation()
    const isClose = isEditCloseDate(new Date(booking.startDate))
    const disabled =
      booking.status === 'CANCELLED' ||
      booking.status === 'CANCELLING' ||
      booking.status === 'SENDING' ||
      isClose
    let tooltip = null
    if (booking.status === 'SENDING')
      tooltip =
        'pages.bookings.bookingsPage.editBookingButton.tooltipDisallowedSending'
    else if (booking.status === 'CANCELLING' || booking.status === 'CANCELLED')
      tooltip =
        'pages.bookings.bookingsPage.editBookingButton.tooltipDisallowedCancelling'
    else if (isClose)
      tooltip =
        'pages.bookings.bookingsPage.editBookingButton.tooltipDisallowedTimeframe'

    const button = (
      <LinkButton
        to={disabled ? '#' : `/bookings/${booking.id}/edit`}
        variant="secondary"
        size="small"
        disabled={disabled}
      >
        {t('pages.bookings.bookingsPage.editBookingButton.change')}
      </LinkButton>
    )

    return tooltip ? (
      <WbTooltipHost>
        {button}
        <WbTooltip>{t(tooltip)}</WbTooltip>
      </WbTooltipHost>
    ) : (
      <>{button}</>
    )
  }
